export default defineAppConfig({
  goodbitsLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    goodbitsLayer?: {};
  }
}
